import React, { useState, useEffect } from "react";
import classes from "./style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import TransactionFilters from "./TransactionFilters";

import RCoin from "../../assets/images/icons/RCoin.png";
import { IoArrowDownOutline } from "react-icons/io5";
import { IoMdArrowUp } from "react-icons/io";

import appApi from "../../assets/utils/AppApi";
import { convertToShamsi } from "../../assets/utils/ConvertToShamsi";
import Loading from "../../assets/containers/loadingDialog";
import errorHandler from "../../assets/utils/ErrorHandler";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";

const Transactions = () => {
  const [filter, setFilter] = useState("");
  const [items, setitems] = useState([]);
  const [loading, setLoading] = useState(false);

  const getItems = async (page, searchString) => {
    setLoading(true);
    try {
      await appApi
        .get(
          `/point/user/getall?page=${page}&limit=999&searchString=${searchString}`
        )
        .then(({ data }) => {
          setitems(data.docs);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getItems(1, filter);
    return () => {
      setitems([]);
    };
  }, [filter]);

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <TransactionFilters
          selected={filter}
          handleClick={(type) => setFilter(type)}
        />
        <div className="my-4">
          {!loading && items.length === 0 ? (
            <NoResultAlter className={"w-100  py-5 my-5"} />
          ) : (
            items.map((item) => (
              <div className={classes.transationItem} key={item._id}>
                <div className={classes.transactionHeading}>
                  <div className={"d-flex align-items-center"}>
                    <div className={classes.arrowIconContainer}>
                      {item.type === "Spend" ? (
                        <IoMdArrowUp color="red" fontSize={"18px"} />
                      ) : (
                        <IoArrowDownOutline color="blue" fontSize={"18px"} />
                      )}
                    </div>
                    <span className={classes.transactionType}>
                      {item.type === "Spend" ? "برداشت" : "واریز"}
                    </span>
                  </div>
                  <div className={classes.dataContainer}>
                    {convertToShamsi(item.createdAt)}
                  </div>
                </div>
                <div className={classes.coinContainer}>
                  <img src={RCoin} alt="coin" />
                  <span>{item.point}</span>
                </div>
                <p
                  className={classes.transactionDesc}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></p>
              </div>
            ))
          )}

          {loading && (
            <Loading
              className={"w-100 d-flex justify-content-center my-5 py-5"}
            />
          )}
        </div>
      </div>
    </AnimatedPageContainer>
  );
};

export default Transactions;
